export const COMMENT_QUERY_PARAMETER_NAME = 'comment';
export const CREATE_COMMENT_NAME = 'createComment';
export const REPLY_TO_COMMENT_NAME = 'replyTo';
